import React from "react";

import Image from "next/image";

import styles from "styles/developers.module.css";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";

import StartDeveloping from "assets/developers/start-developing.png";
import ExtensionsHighlight from "assets/developers/extensions-highlight.png";

import { Page } from "types/page";
import Container from "components/Container";
import ReadyForTakeOff from "components/ReadyForTakeOff";
import SocialFooter from "components/SocialFooter";
import Hero from "components/developers/Hero";
import EcoSystem from "components/developers/EcoSystem";
import Testimonials from "components/developers/Testimonials";

const Developers: Page = () => {
  return (
    <div>
      <Hero />
      <Container size="lg">
        <div className={styles.highlight}>
          <div className={styles.startDeveloping}>
            <div className={styles.imgContainer}>
              <div>
                <Image
                  src={StartDeveloping}
                  width={560}
                  height={306}
                  layout="fixed"
                  alt="An example screenshot of a code editor showing a simpe Raycast command"
                />
              </div>
            </div>
            <div className={styles.text}>
              <h3>Start developing</h3>
              <p>
                Build rich extensions with React, Node.js and TypeScript. Our docs cover guides, examples, references
                and more to help you build extensions and share them with our community.
              </p>
              <a href="https://developers.raycast.com" className={styles.cta}>
                View Documentation
              </a>
            </div>
          </div>
          <div className={styles.extensions}>
            <div className={styles.imgContainer}>
              <div>
                <Image
                  src={ExtensionsHighlight}
                  width={586}
                  height={289}
                  layout="fixed"
                  alt="A list of extension icons"
                />
              </div>
            </div>
            <div className={styles.text}>
              <h3>Extensions</h3>
              <p>
                Complete tasks, create lists, browse media and improve your workflow. Manage all of your Extensions
                through a set of built-in developer tools, and publish Extensions to the Raycast Store, and share with
                the world.
              </p>
              <a href="/store" className={styles.cta}>
                View Extensions
              </a>
            </div>
          </div>
        </div>
      </Container>

      <EcoSystem />

      <Testimonials />

      <Container size="lg">
        <ReadyForTakeOff />
        <SocialFooter />
      </Container>
    </div>
  );
};

Developers.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <Navbar />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default Developers;
